import {
  BikeIcon,
  RunIcon,
  SwimIcon
} from 'components/Checkout/Relay/Common.Relay.style'
import {
  ElevationDownIcon,
  ElevationUpIcon,
  NordicWalkIcon,
  WalkIcon
} from 'components/RacePage/RaceDistancesAndElevations/DistanceOrElevation.style'

export enum DistanceOrElevationLogoEnum {
  RUN = 'RUN',
  HIKE = 'HIKE',
  NORDIC_HIKE = 'NORDIC_HIKE',
  D_PLUS = 'D+',
  D_MINUS = 'D-',
  BIKE = 'BIKE',
  SWIM = 'SWIM'
}

export const DistanceOrElevationLogo = ({
  distanceLogoEnum
}: {
  distanceLogoEnum: DistanceOrElevationLogoEnum
}) => {
  switch (distanceLogoEnum) {
    case DistanceOrElevationLogoEnum.RUN:
      return <RunIcon />
    case DistanceOrElevationLogoEnum.HIKE:
      return <WalkIcon />
    case DistanceOrElevationLogoEnum.NORDIC_HIKE:
      return <NordicWalkIcon />
    case DistanceOrElevationLogoEnum.D_MINUS:
      return <ElevationDownIcon />
    case DistanceOrElevationLogoEnum.D_PLUS:
      return <ElevationUpIcon />
    case DistanceOrElevationLogoEnum.BIKE:
      return <BikeIcon />
    case DistanceOrElevationLogoEnum.SWIM:
      return <SwimIcon />
    default:
      return <></>
  }
}
